module.exports = __webpack_public_path__ + "static/img/red_button.6bca3211.png";